var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoritefile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.07,
    height: 38.937,
    viewBox: "0 0 34.07 38.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "favoritefile",
    d: "M31.645,38.937H2.443a2.371,2.371,0,0,1-1.711-.7A2.32,2.32,0,0,1,.009,36.5V2.471A2.322,2.322,0,0,1,.731.741a2.365,2.365,0,0,1,1.711-.7H19.478V13.422a1.234,1.234,0,0,0,1.217,1.217H34.079V36.5a2.4,2.4,0,0,1-2.434,2.434ZM15.1,23.575l-2.928-6.54-2.928,6.54-6.806.913,5.02,4.943L6.17,36.5l6.008-3.46,6.008,3.46-1.292-7.072,5.02-4.943ZM21.911,0a2.276,2.276,0,0,1,1.673.685l9.772,9.772a2.382,2.382,0,0,1,.722,1.749H21.911Z",
    transform: "translate(-0.009)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritefile);
export default __webpack_public_path__ + "static/media/favoritefile.3a0bd524a3da268ffe4003390ad6c5da.svg";
export { ForwardRef as ReactComponent };